/*
 * Copyright 2018 Teralytics
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
import { getColorsRGBA, getDiffColorsRGBA, isDiffColorsRGBA } from '@flowmap.gl/core';
import * as React from 'react';
import Disc from './Disc';
const styles = {
    outer: {
        display: 'flex',
        flexDirection: 'column',
    },
    item: {
        outer: {
            display: 'flex',
            flexDirection: 'row',
            padding: '3px 0',
            alignItems: 'center',
        },
        caption: {
            marginLeft: 2,
        },
    },
};
const LocationTotalsLegend = ({ diff, colors, aboutEqualText, moreOutgoingText, moreIncomingText }) => {
    const size = 20;
    const colorsRGBA = diff ? getDiffColorsRGBA(colors) : getColorsRGBA(colors);
    const pos = isDiffColorsRGBA(colorsRGBA) ? colorsRGBA.positive.locationCircles : colorsRGBA.locationCircles;
    const neg = isDiffColorsRGBA(colorsRGBA) ? colorsRGBA.negative.locationCircles : undefined;
    return (React.createElement("div", { style: styles.outer },
        React.createElement("div", null,
            React.createElement("div", { style: styles.item.outer },
                React.createElement(Disc, { size: size, inner: pos.inner, outer: pos.inner, outline: pos.inner }),
                neg && React.createElement(Disc, { size: size, inner: neg.inner, outer: neg.inner, outline: neg.inner }),
                React.createElement("div", { style: styles.item.caption }, aboutEqualText || 'outgoing ≅ incoming')),
            React.createElement("div", { style: styles.item.outer },
                React.createElement(Disc, { size: size, inner: pos.inner, outer: pos.outgoing, outline: pos.inner }),
                neg && React.createElement(Disc, { size: size, inner: neg.inner, outer: neg.outgoing, outline: neg.inner }),
                React.createElement("div", { style: styles.item.caption }, moreOutgoingText || 'more outgoing')),
            React.createElement("div", { style: styles.item.outer },
                React.createElement(Disc, { size: size, inner: pos.inner, outer: pos.incoming, outline: pos.incoming }),
                neg && React.createElement(Disc, { size: size, inner: neg.inner, outer: neg.incoming, outline: neg.incoming }),
                React.createElement("div", { style: styles.item.caption }, moreIncomingText || 'more incoming')))));
};
export default LocationTotalsLegend;
//# sourceMappingURL=LocationTotalsLegend.js.map